export default __webpack_public_path__ + "static/media/device-LT-128x128.08482e3b.png";